import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Service Worker registration for Braze push notifications
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    const swPath = `${process.env.PUBLIC_URL}/service-worker.js`;
    navigator.serviceWorker.register(swPath).catch(error => {
      console.error('Service Worker registration failed:', error);
    });
  });
}
